import { Factory, trait } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  isActive: false,
  floorPlanUrl: () => 'https://picsum.photos/200/300',
  floorPlanImgName: () => `${faker.lorem.word()}.svg`,
  floorNumber: (i) => i,
  name: () => faker.lorem.word(),
  building: () => faker.lorem.word(),

  withDesks: trait({
    afterCreate(floor, server) {
      server.createList('desk', 5, { floor, assignedTo: null });
    },
  }),

  withOnePlacedDesk: trait({
    afterCreate(floor, server) {
      server.create('desk', { floor });
    },
  }),

  withDesksWithoutPositions: trait({
    afterCreate(floor, server) {
      server.createList('desk', 5, { floor, xPos: null, yPos: null });
    },
  }),

  withUnassignableDesks: trait({
    afterCreate(floor, server) {
      server.createList('desk', 5, { floor, enabled: false });
    },
  }),
});
